import { render, staticRenderFns } from "./business.component.html?vue&type=template&id=0be6e9f1&scoped=true&external"
import script from "./business.component.ts?vue&type=script&lang=ts&external"
export * from "./business.component.ts?vue&type=script&lang=ts&external"
import style0 from "./business.component.scss?vue&type=style&index=0&id=0be6e9f1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be6e9f1",
  null
  
)

export default component.exports